import { useEffect, useRef, useState } from 'react';
import useReduceMotion from './useReducedMotion';

/**
 * Scrolls to an element with the given elementId
 * @param elementId ID of the element to scroll to
 * @param dependentParams Additional dependencies for the scroll effect
 * @param additionalConditions Optional conditions that must be met to trigger the scroll
 */
const useScrollToElement = (
    elementId: string | null,
    dependentParams: any[] = [],
    additionalConditions: boolean[] = []
) => {
    const isReducedMotion = useReduceMotion();
    const [scrollCount, setScrollCount] = useState(0);

    useEffect(() => {
        if (!elementId) return;

        const element = document.getElementById(elementId);
        const shouldScroll = additionalConditions.length === 0 || additionalConditions.some((condition) => condition);

        if (element && shouldScroll) {
            element.focus();
            element.scrollIntoView({
                behavior: isReducedMotion ? 'instant' : 'smooth',
            });
        }
    }, [...dependentParams, elementId, isReducedMotion, scrollCount]);

    // Forces a re-scroll even when clicking the same element
    const triggerScroll = () => {
        setScrollCount(scrollCount + 1);
    };

    return triggerScroll;
};

export default useScrollToElement;
